export default __webpack_public_path__ + "static/media/companies-infobae.ed92b282.svg";